import React from 'react';
import SweetAlert from "react-bootstrap-sweetalert";

const EsignConfirmation = (props: any) => {

  return <SweetAlert
    customClass={"esign-confirm-alert"}
    title="Your E-Signature is needed. You consent to signing this document electronically."
    reverseButtons={true}
    customButtons={
      <React.Fragment>
        <button onClick={props.onConfirm} className="btn e-sign-confirm-btn">Accept mobile signature</button>
        <button onClick={props.onCancel} className="btn e-sign-cancel-btn">
          Sign from computer
          <div className="cancel-description">(I will sign this document from my personal computer)</div>
        </button>
      </React.Fragment>
    }
    {...props}>
    {props.children}
  </SweetAlert>
}

export default EsignConfirmation;